<template>
    <actions-menu v-model:dialogEdit="editRequestDialog" :ShowDialogConsult="false" dialogConsult="VehicleDetails"
        v-model:dialogConsult="editRequestDialog" :Id="Id" :dialogConsultUrl="idVehicle" v-model:dialogDelete="dialog"
        :ShowDialogEdit="isEditMode" :ShowDialogDelete="false" />

    <v-dialog v-model="editRequestDialog">
        <v-card elevation="0" width="1100px" class="py-2" style="border-radius: 12px">
            <v-card-title>
                <span class="title">{{ $t("Delivery.Vehicule.Edit") }}</span>
            </v-card-title>

            <div class="row justify-content-start ma-4">
                <div class="col-4">
                    <v-card-title class="text-left">{{ $t("Delivery.Vehicule.marque") }}</v-card-title>
                    <v-text-field v-model="vehicle.brand" maxlength="50" :readonly="!isDeliveryResult"
                        :class="!isDeliveryResult ? 'readonly-field' : ''"></v-text-field>
                </div>

                <div class="col-4">
                    <v-card-title class="text-left">{{ $t("Delivery.Vehicule.model") }}</v-card-title>
                    <v-text-field v-model="vehicle.model" maxlength="50" :readonly="!isDeliveryResult"
                        :class="!isDeliveryResult ? 'readonly-field' : ''"></v-text-field>
                </div>

                <div class="col-4">
                    <v-card-title class="text-left">{{ $t("Delivery.Vehicule.Matricule") }}</v-card-title>
                    <v-text-field v-model="vehicle.licensePlate" maxlength="20" :readonly="!isDeliveryResult"
                        :class="!isDeliveryResult ? 'readonly-field' : ''"></v-text-field>
                </div>
            </div>

            <div class="row ma-4">
                <div class="col-4">
                    <v-card-title class="text-left">{{ $t("Delivery.Vehicule.Capacite") }}</v-card-title>
                    <v-text-field v-model="vehicle.maximumLoad" type="number" maxlength="10"
                        :readonly="!isDeliveryResult" :class="!isDeliveryResult ? 'readonly-field' : ''"></v-text-field>
                </div>

                <div class="col-4">
                    <v-card-title class="text-left">{{ $t("Delivery.Vehicule.type") }}</v-card-title>
                    <v-autocomplete v-model="selectedProductTypes" :items="productTypes" item-title="name"
                        item-value="id" multiple chips hide-details :readonly="!isDeliveryResult"
                        :class="!isDeliveryResult ? 'readonly-field' : ''">
                        <template v-slot:selection="{ item, index }">
                            <v-chip :key="index" closable @click:close="removeProductType(index)" color="primary">
                                {{ item.name }}
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </div>
            </div>

            <card-actions :yes="updateVehicleInfo" v-model:no="editRequestDialog" :loader="loader"
                :yesDisable="!isDeliveryResult || loader" width="300px" :yesTitle="$t('actions.save')" />
        </v-card>
    </v-dialog>
</template>

<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import cardActions from "@/genericComponent/cardActions.vue";
import { updateAutoMobile, getAllProductTypes } from "@/api/index";

export default {
    components: { actionsMenu, cardActions },
    props: ["idVehicle", "Id", "getBrand", "isDeliveryResult"],

    created() {
        this.FetchProductsTypes();

        if (this.getBrand) {
            this.vehicle = {
                brand: this.getBrand.brand || "",
                model: this.getBrand.model || "",
                licensePlate: this.getBrand.licensePlate || "",
                maximumLoad: this.getBrand.maximumLoad || null,
                productCarryingTypes: this.getBrand.productCarryingTypes || [],
            };

            this.selectedProductTypes = this.vehicle.productCarryingTypes.map(pt => pt.id);
        }
    },

    data() {
        return {
            editRequestDialog: false,
            loader: false,
            vehicle: {
                brand: "",
                model: "",
                licensePlate: "",
                maximumLoad: null,
                productCarryingTypes: [],
            },
            productTypes: [],
            selectedProductTypes: [],
        };
    },

    methods: {
        async FetchProductsTypes() {
            try {
                const response = await getAllProductTypes();
                this.productTypes = response.data;
            } catch (error) {
                console.error("Error fetching product types:", error);
            }
        },
        removeProductType(index) {
            this.selectedProductTypes.splice(index, 1);
        },
        async updateVehicleInfo() {
            this.loader = true;
            try {
                const formData = new FormData();
                formData.append("Brand", this.vehicle.brand);
                formData.append("Model", this.vehicle.model);
                formData.append("LicensePlate", this.vehicle.licensePlate);
                formData.append("MaximumLoad", this.vehicle.maximumLoad);

                this.selectedProductTypes.forEach(type => {
                    formData.append("productCarryingTypes", type);
                });

                await updateAutoMobile(this.idVehicle, formData);
                this.editRequestDialog = false;
                this.$emit("updateSuccess");
            } catch (error) {
                console.error("Error updating vehicle:", error);
            } finally {
                this.loader = false;
            }
        }
    },
};
</script>

<style scoped>
.title {
    font-size: 18px;
    font-weight: 700;
    font-family: inter;
}

.v-card-title {
    font-family: inter;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
}

.warningHint {
    color: #F25C5C;
    font-size: 14px;
    display: block;
    text-align: left;
}
</style>
